import { Spinner } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Center } from '@/components/ui/center'
import { VStack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'

const UploadingDocuments = ({ isUploading, isFullHeight }: { isUploading: boolean; isFullHeight: boolean }) => {
    const { t } = useTranslation()
    if (!isUploading) {
        return null
    }
    const height = isFullHeight ? '100%' : '96px'
    return (
        <Box backgroundColor="surface.default" height={height} width="99%" minH="96px" mt="16px">
            <Center h="100%">
                <VStack>
                    <Spinner w="16px" h="16px" color="var(--chakra-colors-gray-750)" animationDuration="0.85s" />
                    <Text color="rgba(84, 79, 64, 0.7)" fontSize="14px" letterSpacing="0.25px">
                        {t('documents.uploadingDocuments')}
                    </Text>
                </VStack>
            </Center>
        </Box>
    )
}

export default UploadingDocuments
